// extracted by mini-css-extract-plugin
export default {"betPopupTitle":"styles_betPopupTitle__CKceV","infoicon":"styles_infoicon__3DG7K","btnContainer":"styles_btnContainer__JmaNE"};